import { GuideCard } from "@/components/GuideCard";
import type { Guide } from "@/data/guides";

interface GuideGridProps {
  guides: Guide[];
  onNavigate: (path: string) => void;
  loading?: boolean;
}

export function GuideGrid({ guides, onNavigate, loading }: GuideGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="rounded-lg border bg-card overflow-hidden animate-pulse">
            <div className="aspect-[16/9] bg-muted" />
            <div className="p-4 space-y-3">
              <div className="flex gap-2">
                <div className="h-5 bg-muted rounded w-16" />
                <div className="h-5 bg-muted rounded w-16" />
              </div>
              <div className="h-6 bg-muted rounded w-3/4" />
              <div className="h-4 bg-muted rounded w-full" />
              <div className="h-4 bg-muted rounded w-2/3" />
              <div className="flex gap-3">
                <div className="h-4 bg-muted rounded w-24" />
                <div className="h-4 bg-muted rounded w-20" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (guides.length === 0) {
    return (
      <div className="text-center py-16">
        <p className="text-muted-foreground text-lg mb-2">Keine Ratgeber gefunden</p>
        <p className="text-sm text-muted-foreground">
          Versuchen Sie eine andere Kategorie oder Suche
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {guides.map(guide => (
        <GuideCard key={guide.id} guide={guide} onNavigate={onNavigate} />
      ))}
    </div>
  );
}
